import * as React from 'react';

import type { WosIconProps } from 'types/common_types';

function collagewall(props: WosIconProps) {
  const { className } = props;

  return (
    <svg viewBox="0 0 79 60" className={className}>
      <path
        fill="currentColor"
        d="M36.063 14.484h-6.842c-0.872 0-1.579-0.707-1.579-1.579v0-6.842c0-0.872 0.707-1.579 1.579-1.579v0h6.842c0.872 0 1.579 0.707 1.579 1.579v0 6.842c0 0.872-0.707 1.579-1.579 1.579v0zM30.8 11.326h3.684v-3.684h-3.684z"
      />
      <path
        fill="currentColor"
        d="M8.695 41.853h-6.842c-0.872 0-1.579-0.707-1.579-1.579v0-6.842c0-0.872 0.707-1.579 1.579-1.579v0h6.842c0.872 0 1.579 0.707 1.579 1.579v0 6.842c0 0.872-0.707 1.579-1.579 1.579v0zM3.432 38.695h3.684v-3.684h-3.684z"
      />
      <path
        fill="currentColor"
        d="M36.063 28.168h-34.211c-0.872 0-1.579-0.707-1.579-1.579v0-6.842c0-0.872 0.707-1.579 1.579-1.579v0h34.211c0.872 0 1.579 0.707 1.579 1.579v0 6.842c0 0.872-0.707 1.579-1.579 1.579v0zM3.432 25.011h31.053v-3.684h-31.053z"
      />
      <path
        fill="currentColor"
        d="M36.063 55.537h-20.526c-0.872 0-1.579-0.707-1.579-1.579v0-20.526c0-0.872 0.707-1.579 1.579-1.579v0h20.526c0.872 0 1.579 0.707 1.579 1.579v0 20.526c0 0.872-0.707 1.579-1.579 1.579v0zM17.116 52.379h17.368v-17.368h-17.368z"
      />
      <path
        fill="currentColor"
        d="M49.747 55.537h-6.842c-0.872 0-1.579-0.707-1.579-1.579v0-6.842c0-0.872 0.707-1.579 1.579-1.579v0h6.842c0.872 0 1.579 0.707 1.579 1.579v0 6.842c0 0.872-0.707 1.579-1.579 1.579v0zM44.484 52.379h3.684v-3.684h-3.684z"
      />
      <path
        fill="currentColor"
        d="M77.116 28.168h-6.842c-0.872 0-1.579-0.707-1.579-1.579v0-6.842c0-0.872 0.707-1.579 1.579-1.579v0h6.842c0.872 0 1.579 0.707 1.579 1.579v0 6.842c0 0.872-0.707 1.579-1.579 1.579v0zM71.853 25.011h3.684v-3.684h-3.684z"
      />
      <path
        fill="currentColor"
        d="M77.116 41.853h-34.211c-0.872 0-1.579-0.707-1.579-1.579v0-6.842c0-0.872 0.707-1.579 1.579-1.579v0h34.211c0.872 0 1.579 0.707 1.579 1.579v0 6.842c0 0.872-0.707 1.579-1.579 1.579v0zM44.484 38.695h31.053v-3.684h-31.053z"
      />
      <path
        fill="currentColor"
        d="M63.432 28.168h-20.526c-0.872 0-1.579-0.707-1.579-1.579v0-20.526c0-0.872 0.707-1.579 1.579-1.579v0h20.526c0.872 0 1.579 0.707 1.579 1.579v0 20.526c0 0.872-0.707 1.579-1.579 1.579v0zM44.484 25.011h17.368v-17.368h-17.368z"
      />
    </svg>
  );
}

export default collagewall;
